<template>
  <v-navigation-drawer :value="true" permanent>
    <v-list dense nav class="py-4">
      <v-list-item v-for="item in items" :key="item.title" link :to="item.to">
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import paramsDistrict from '@/common/paramsDistrict.js'
export default {
  name: 'MasterdataNavigation',

  computed: {
    items() {
      return [
        {
          title: 'Orsaker',
          to: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/masterdata/reasons`
        },
        {
          title: 'Prognoser',
          to: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/masterdata/forecasts`
        },
        {
          title: 'Busstids matris',
          to: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/masterdata/bus-matrix`
        }
      ]
    }
  }
}
</script>
